module.exports = __webpack_public_path__ + "img/folder_managed.fcb408b5.svg";